import React, { Component } from 'react';
import cn from 'classnames';
import NavLink from 'components/Navigation/NavLink';
import { withSimoSub } from 'decorators/withSub';
import { showActivateSub as showSimoActivateSub } from 'helpers/portLinks/simo';
import { UserNav } from './UserNav';
import Caret from 'images/icons/Caret';
import AnimateHeight from 'react-animate-height';
import { splitLongText } from 'helpers/text';
import { can, permActions } from 'permissions';
import { getSubStatus } from 'helpers/subs';

const localStorageKey = '__openSimoSubNav';
class SimoSubNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen:
        !window.localStorage.getItem(localStorageKey) ||
        window.localStorage.getItem(localStorageKey) === 'true',
    };
  }

  handleToggleMenu = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
    window.localStorage.setItem(localStorageKey, isOpen ? 'false' : 'true');
  };

  render() {
    const { sub, user, loggedInUser } = this.props;
    const { isOpen } = this.state;

    const subId = sub?.id;
    const subStatus = getSubStatus(sub);

    const isActive = subStatus === 'active';
    const isExpired = subStatus === 'expired';
    const isNew = subStatus === 'new';

    const links = [
      { to: `/simo/subscriptions/${subId}/view`, label: 'View Subscription' },
      {
        to: `/simo/subscriptions/${subId}/edit`,
        label: 'Edit Subscription',
      },
      {
        to: `/simo/subscriptions/${subId}/activate`,
        label: 'Activate Subscription',
        condition: showSimoActivateSub(subStatus),
      },
      { to: 'break1', breakLine: true },
      {
        to: `/simo/subscriptions/${subId}/update-plan`,
        label: 'Update Plan',
        condition: !isNew && !isExpired,
      },
      {
        to: `/simo/subscriptions/${subId}/upcoming-plan`,
        label: 'Upcoming Plan',
        condition: !isNew && !isExpired,
      },
      {
        to: `/simo/subscriptions/${subId}/upgrade-invoice`,
        label: 'Upgrade Invoice',
        condition: isActive,
        permission: can(loggedInUser, permActions.UPGRADE_SIMO_INVOICE),
      },
      { to: 'break2', breakLine: true },
      {
        to: `/simo/subscriptions/${subId}/modify-auto-renew`,
        label: 'Modify Auto Renew',
        condition: !isNew && !isExpired,
      },
      {
        to: `/simo/subscriptions/${subId}/expire-subscription`,
        label: 'Expire Subscription',
        condition: !isNew && !isExpired,
        permission: can(loggedInUser, permActions.EXPIRE_SIMO_DEVICE),
      },
    ];

    return (
      <div className="col-xs-12 col-sm-8 col-lg-12 SubNav">
        {user && <UserNav user={user} loggedInUser={loggedInUser} />}
        {sub && (
          <div className="col-xs-6 col-lg-12">
            <br />
            <div
              className="mar-b-5"
              onClick={this.handleToggleMenu}
              style={{ cursor: 'pointer' }}
            >
              <div>
                <strong>
                  {splitLongText(sub.first_name)} {splitLongText(sub.last_name)}
                </strong>
              </div>
              <div>
                <strong>Sub ID: {sub.id}</strong>
              </div>
              <div>
                <strong>Device SN:</strong>
              </div>
              <div className="d-flex">
                <strong>{sub.device_sn}</strong>
                <Caret
                  className={cn({
                    'main-nav-caret': true,
                    'main-nav-caret-up': isOpen,
                  })}
                />
              </div>
            </div>
            <AnimateHeight duration={300} height={isOpen ? 'auto' : 0}>
              {links.map((link) => (
                <NavLink key={link.to} {...link} />
              ))}
            </AnimateHeight>
          </div>
        )}
      </div>
    );
  }
}

export default withSimoSub(SimoSubNav);
